<template>
  <div class="scoringpaper-wrapper">
    <p class="scoringpaper-question">
      <span>Q{{ questionIndex }}. </span>{{ scoringMethod }}
    </p>
    <div class="scorginpaper-imagebox">
      <img
        v-if="scorecard !== null"
        class="scoringpaper-image"
        :src="readImgFile(scorecard)"
        alt=""
      />
    </div>
    <div v-for="(answer, index) in answers" :key="index" class="scoringpaper-answerbox">
      <div class="scoringpaper-answer flex-row">
        <p>{{ index + 1 }}.</p>
        <div>
          {{ answer.content }}
        </div>
      </div>
      <div class="scoringpaper-score">
        <div v-for="num in maximumScore" :key="num">
          <label><input type="radio" :name="`score-${index}`" />{{ num - 1 }}</label>
        </div>
      </div>
      <div v-if="feedbackStatus" class="scoringpaper-feedback">
        <p class="scoringpaper-feedback-question">※ {{ feedbackQuestion }}</p>
        <input class="feedback-input" type="text" :placeholder="placeholder" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoringPaperQuestion',
  props: {
    questionIndex: { type: Number, default: 0 },
    scoringMethod: { type: String, default: '다음 응답을 보고 적절한 점수를 선택해주세요.' },
    scorecard: { type: File, default: null },
    answers: { type: Array, default: [] },
    maximumScore: { type: Number, default: 5 },
    feedbackStatus: { type: Boolean, default: false },
    feedbackQuestion: { type: String, default: '해당 점수를 준 이유를 작성해주세요.' },
  },
  methods: {
    readImgFile(file) {
      return window.URL.createObjectURL(file);
    },
  },
  data() {
    return {
      placeholder:
        this.$i18n.locale === 'eng' ? 'Please provide feedback.' : '피드백을 입력해주세요.',
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.placeholder =
        newLocale === 'eng' ? 'Please provide feedback.' : '피드백을 입력해주세요.';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/studentScoringPaper.scss';

.scorginpaper-wrapper {
  padding: 0 20%;
}
</style>
